/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KpiValueFormat } from './kpi-value-format';
import { KpiI18nDto } from './kpi-i18n-dto';
import { ChartConfigurationSchema } from './chart-configuration-schema';
import { KpiParameterDto } from './kpi-parameter-dto';


export interface CreateKpiDto { 
    /**
     * Stable key within the program.
     */
    key: string;
    /**
     * Metric presentation type. count, amount and percentage render one value; trend returns one row per time bucket (bucket, value) and needs valueFormat; chart requires chartConfig. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    type: CreateKpiDto.TypeEnum;
    /**
     * How a trend KPI\'s values are formatted. Required when type is trend; must be null or omitted for every other type. A percentage value is a ratio, so 0.25 is shown as 25%: never multiply by 100 in SQL.
     */
    valueFormat?: KpiValueFormat | null;
    /**
     * Parameterized, read-only SQL using {{placeholders}}.
     */
    sql: string;
    /**
     * Required when type is chart; must be null or omitted for scalar metric types.
     */
    chartConfig?: ChartConfigurationSchema | null;
    /**
     * Parameters the SQL declares as `{{placeholders}}`, with their type, default and option source.
     */
    parameters?: Array<KpiParameterDto>;
    /**
     * Plain-language explanation of what the SQL computes, shown next to the metric and used when an agent has to pick between KPIs.
     */
    queryExplanation?: string;
    /**
     * Localized KPI copy keyed by locale. English (en) and German (de) are required; additional locale keys are allowed.
     */
    i18n: KpiI18nDto;
    /**
     * Search and categorization tags for this KPI.
     */
    tags?: Array<string>;
    /**
     * Artifact this KPI was promoted from (BI-internal lineage).
     */
    sourceArtifactId?: string;
}
export namespace CreateKpiDto {
    export const TypeEnum = {
        Amount: 'amount',
        Count: 'count',
        Chart: 'chart',
        Percentage: 'percentage',
        Trend: 'trend'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


